import React, { useState } from 'react';
import emailjs from '@emailjs/browser';

const SalesRepForm = () => {
  const [formData, setFormData] = useState({
    from_name: '',
    phone_number: '',
    reply_to: '',
    company_name: '',
    preferred_time: '',
    additional_info: ''
  });
  const [isSending, setIsSending] = useState(false);

  const formStyle = {
    maxWidth: '600px',
    margin: '2rem auto',
    padding: '2rem',
    borderRadius: '8px',
    boxShadow: '0 0 20px rgba(0,0,0,0.1)',
    backgroundColor: '#ffffff'
  };

  const labelStyle = {
    fontWeight: '500',
    marginBottom: '0.5rem',
    color: '#212529'
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSending(true);

    try {
      emailjs.init('hW_eDezKFNuokT_2c'); // Using your existing EmailJS public key

      await emailjs.sendForm(
        'default_service',
        'template_jdinw0g', // Using your existing EmailJS template
        e.target
      );

      // Reset form
      setFormData({
        from_name: '',
        phone_number: '',
        reply_to: '',
        company_name: '',
        preferred_time: '',
        additional_info: ''
      });
      alert('Application submitted successfully! We will contact you soon.');
    } catch (error) {
      alert('Failed to submit application. Please try again.');
      console.error('EmailJS Error:', error);
    } finally {
      setIsSending(false);
    }
  };

  return (
    <div style={formStyle}>
      <h3 style={{ textAlign: 'center', marginBottom: '1.5rem', color: '#2d3748' }}>
        Sales Representative Application
      </h3>
      
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label htmlFor="from_name" className="form-label" style={labelStyle}>
            Full Name
          </label>
          <input
            type="text"
            className="form-control"
            id="from_name"
            name="from_name"
            value={formData.from_name}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <label htmlFor="phone_number" className="form-label" style={labelStyle}>
            Phone Number
          </label>
          <input
            type="tel"
            className="form-control"
            id="phone_number"
            name="phone_number"
            value={formData.phone_number}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <label htmlFor="reply_to" className="form-label" style={labelStyle}>
            Email Address
          </label>
          <input
            type="email"
            className="form-control"
            id="reply_to"
            name="reply_to"
            value={formData.reply_to}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <label htmlFor="company_name" className="form-label" style={labelStyle}>
            Associated Dispensary or Cannabis Company (if any)
          </label>
          <input
            type="text"
            className="form-control"
            id="company_name"
            name="company_name"
            value={formData.company_name}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label htmlFor="preferred_time" className="form-label" style={labelStyle}>
            Best Time for Onboarding Zoom Session
          </label>
          <select
            className="form-control"
            id="preferred_time"
            name="preferred_time"
            value={formData.preferred_time}
            onChange={handleChange}
            required
          >
            <option value="">Select a time preference</option>
            <option value="Weekday Mornings">Weekday Mornings</option>
            <option value="Weekday Afternoons">Weekday Afternoons</option>
            <option value="Weekday Evenings">Weekday Evenings</option>
            <option value="Weekend Mornings">Weekend Mornings</option>
            <option value="Weekend Afternoons">Weekend Afternoons</option>
            <option value="Weekend Evenings">Weekend Evenings</option>
          </select>
        </div>

        <div className="mb-4">
          <label htmlFor="additional_info" className="form-label" style={labelStyle}>
            Additional Information (Optional)
          </label>
          <textarea
            className="form-control"
            id="additional_info"
            name="additional_info"
            value={formData.additional_info}
            onChange={handleChange}
            style={{ minHeight: '100px', resize: 'vertical' }}
          />
        </div>

        <button
          type="submit"
          className={`btn btn-primary w-100 ${isSending ? 'disabled' : ''}`}
          disabled={isSending}
          style={{
            backgroundColor: '#28a745',
            border: 'none',
            padding: '0.75rem',
            fontSize: '1.1rem',
            fontWeight: '500'
          }}
        >
          {isSending ? 'Submitting...' : 'Submit Application'}
        </button>
      </form>
    </div>
  );
};

export default SalesRepForm;